import * as React from 'react';
import { UIText1 } from '@cian/ui-kit';
import { IconMapCar16 } from '@cian/ui-kit-design-tokens/icons';

import * as styles from './highway.css';

export const Highway = ({ name }: { name: string }) => {
  return (
    <div className={styles['highway']}>
      <div className={styles['icon']}>
        <IconMapCar16 color="gray60_100" />
      </div>
      <UIText1 color="text-primary-default">{name}</UIText1>
    </div>
  );
};
